import React, { memo, useContext, useMemo } from 'react';
import { WelcomePageConfigContext } from '../../../../shared/context/welcome-page-config-context';
import { normalizeUrl } from '../../../../shared/helpers/url.helper';
import { Skeleton } from '@mui/material';
import RedirectToDashboard from '../welcomeMessage/redirectToDashboard';
import './welcomePageTopRightAside.scss';

const WelcomePageTopRightAside = () => {
  const { welcomePageVideo, isConfigLoading } = useContext(
    WelcomePageConfigContext,
  );

  const videoUrl = useMemo(() => {
    const url = welcomePageVideo?.url || null;
    return url ? normalizeUrl(url) : null;
  }, [welcomePageVideo]);

  if (isConfigLoading) {
    return <Skeleton variant="rounded" width="100%" height={180} />;
  }

  if (!videoUrl) {
    return <RedirectToDashboard />;
  }

  return (
    <div className="welcome-page-top-right-aside">
      <video
        className="welcome-page-video"
        src={videoUrl}
        controls
        preload="auto"
      />
    </div>
  );
};

export default memo(WelcomePageTopRightAside);
